import {
  Menu, MenuButton, MenuGroup, MenuItem, MenuList,
  styled,
} from "@chakra-ui/react";
import ProfileImage from "../../assets/img/profile.png"
import Image from "../global/Image";
import {useDispatch, useSelector} from "react-redux";
import {logout, selectUser} from "../../store/features/sessionSlice";
import {ROUTES} from "../../utils/consts/router";
import {useNavigate} from "react-router-dom";


const Profile = styled("div", {
  baseStyle: {
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    padding: "10px",
    marginTop: "15px",
  }
})

const Head = styled("div", {
  baseStyle: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "32px",
    width: "32px",
    cursor: "pointer",
    backgroundColor: "#F5F5F5",
    borderRadius: "10px",
  }
})

const ProfileName = styled("div", {
  baseStyle: {
    marginLeft: "10px",
    fontFamily: "Mabry Pro",
    fontWeight: "normal",
    fontSize: "15px",
    color: "#48463f",
  }
})

function OverlayProfile() {

  const navigate = useNavigate();
  const user = useSelector(selectUser);
  const dispatch = useDispatch();

  const handleSignOut = () => {
    localStorage.removeItem("token");
    dispatch(logout());
    navigate(ROUTES.LOGIN);
  }

  return (
    <Menu>
      <MenuButton style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}>
        <Profile>
          <Head>
            <Image src={ProfileImage} alt="Profile" width={50} borderRadius={10}/>
          </Head>
          <ProfileName>{user?.first_name}</ProfileName>
        </Profile>
      </MenuButton>
      <MenuList>
        <MenuGroup title='Profil'>
          <MenuItem onClick={() => navigate(ROUTES.PROFILE)}>Mon compte</MenuItem>
          <MenuItem onClick={() => navigate(ROUTES.MISSIONS_CHILD)}>Mes études</MenuItem>
          <MenuItem onClick={handleSignOut}>Déconnexion</MenuItem>
        </MenuGroup>
      </MenuList>
    </Menu>
  )
}

export default OverlayProfile;